The `PositionOpening` that this draft profile is associated with.
